import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import {
  ShowTableDashboardCabangNplDetailGadai,
  ShowTableDashboardCabangNplDetailFidusia,
} from "../../../components/ShowTable";
import { formatDate } from "../../../constants/helper";
import { Box, Typography, Divider, Paper, Chip } from "@mui/material";
import { Chart } from "react-google-charts";
import { useNavigate } from "react-router-dom";

const DashboardCabang = () => {
  const { user, setting, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  let tempDate = new Date();
  const [dataBarNplDetailGadai, setDataBarNplDetailGadai] = useState([]);
  const [dataBarNplDetailFidusia, setDataBarNplDetailFidusia] = useState([]);

  const [namaPeriodeLalu, setNamaPeriodeLalu] = useState("");
  const [loadingLaporanNplDetailGadai, setLoadingLaporanNplDetailGadai] =
    useState(false);
  const [loadingLaporanNplDetailFidusia, setLoadingLaporanNplDetailFidusia] =
    useState(false);

  function subtractMonths(date, months) {
    date.setMonth(date.getMonth() - months);
    return date;
  }

  useEffect(() => {
    getBulanLalu();
    getJualsForDashboardSemuaCabangNplDetailGadai();
    getJualsForDashboardSemuaCabangNplDetailFidusia();
  }, []);

  const getBulanLalu = () => {
    try {
      let tempDateName;
      const newBulan = new Date(user.periode.periodeAwal);
      const minOneBulan = subtractMonths(newBulan, 1);
      switch (minOneBulan.getMonth() + 1) {
        case 1:
          tempDateName = "JANUARI";
          break;
        case 2:
          tempDateName = "FEBRUARI";
          break;
        case 3:
          tempDateName = "MARET";
          break;
        case 4:
          tempDateName = "APRIL";
          break;
        case 5:
          tempDateName = "MEI";
          break;
        case 6:
          tempDateName = "JUNI";
          break;
        case 7:
          tempDateName = "JULI";
          break;
        case 8:
          tempDateName = "AGUSTUS";
          break;
        case 9:
          tempDateName = "SEPTEMBER";
          break;
        case 10:
          tempDateName = "OKTOBER";
          break;
        case 11:
          tempDateName = "NOVEMBER";
          break;
        case 12:
          tempDateName = "DESEMBER";
          break;
        default:
          break;
      }
      setNamaPeriodeLalu(`${tempDateName} ${minOneBulan.getFullYear()}`);
    } catch (e) {
      console.log(e);
    }
  };

  const getJualsForDashboardSemuaCabangNplDetailGadai = async () => {
    setLoadingLaporanNplDetailGadai(true);
    try {
      let tempJual = [];

      const allPengajuanGadaisTunggakkan = await axios.post(
        `${tempUrl}/pengajuanGadaisForDashboardCabangNplDetail`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );

      for (let i = 0; i < allPengajuanGadaisTunggakkan.data.length; i++) {
        let tempDataMmg = {
          ...allPengajuanGadaisTunggakkan.data[i],
        };
        tempJual.push(tempDataMmg);
      }

      setDataBarNplDetailGadai(tempJual);
    } catch (e) {
      console.log(e);
    }
    setLoadingLaporanNplDetailGadai(false);
  };

  const getJualsForDashboardSemuaCabangNplDetailFidusia = async () => {
    setLoadingLaporanNplDetailFidusia(true);
    try {
      let tempJual = [];

      const allPengajuanFidusiasTunggakkan = await axios.post(
        `${tempUrl}/pengajuanFidusiasForDashboardSemuaCabangNplDetail`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );

      for (let i = 0; i < allPengajuanFidusiasTunggakkan.data.length; i++) {
        let tempDataMmg = {
          ...allPengajuanFidusiasTunggakkan.data[i],
        };
        tempJual.push(tempDataMmg);
      }

      setDataBarNplDetailFidusia(tempJual);
    } catch (e) {
      console.log(e);
    }
    setLoadingLaporanNplDetailFidusia(false);
  };

  return (
    <Box>
      <Typography color="#757575">Dashboard Cabang</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Dashboard Cabang
      </Typography>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <Divider sx={dividerStyle} />

      <Box sx={{ display: "none" }}>
        <Chart />
      </Box>

      <Paper sx={contentSecondContainer} elevation={20}>
        <Typography sx={[detailText, dividerStyle]}>
          NPL Gadai Per Cabang
        </Typography>
        <Box sx={tableContainer}>
          {loadingLaporanNplDetailGadai ? (
            <Loader />
          ) : (
            <ShowTableDashboardCabangNplDetailGadai
              juals={dataBarNplDetailGadai}
            />
          )}
        </Box>
      </Paper>

      <Paper sx={contentSecondContainer} elevation={20}>
        <Typography sx={[detailText, dividerStyle]}>
          NPL Fidusia Per Cabang
        </Typography>
        <Box sx={tableContainer}>
          {loadingLaporanNplDetailFidusia ? (
            <Loader />
          ) : (
            <ShowTableDashboardCabangNplDetailFidusia
              juals={dataBarNplDetailFidusia}
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default DashboardCabang;

const contentSecondContainer = {
  mt: 4,
};

const subTitleText = {
  fontWeight: "900",
};

const detailText = {
  fontWeight: "900",
  textAlign: "center",
};

const dividerStyle = {
  pt: 4,
};

const graphContainer = {
  p: {
    xs: 0,
    sm: 6,
  },
  display: "flex",
  justifyContent: {
    sm: "space-around",
  },
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
};

const graphWrapper = {
  pt: {
    xs: 4,
    sm: 0,
  },
  width: {
    xs: "300px",
    sm: "400px",
  },
};

const tableContainer = {
  p: 5,
  display: "flex",
  justifyContent: "center",
};
